{
    "Accessibility menu": "Хандалтын цэс",
    "Close": "Хаах",
    "Content adjustments": "Агуулгын тохируулга",
    "Navigation adjustments": "Навигацийн тохируулга",
    "Text Align": "Text Align",
    "Align Left": "Зүүн талд зэрэгцүүлэх",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Фонтын хэмжээг тохируулах",
    "Highlight Title": "Гарчгийг онцлох",
    "Highlight Links": "Холбоосуудыг онцлох",
    "Readable Font": "Уншихад хялбар фонт",
    "Colour adjustments": "Өнгөний тохируулга",
    "Dark Contrast": "Харанхуй ялгарал",
    "Light Contrast": "Гэрэлтэй ялгарал",
    "High Contrast": "Өндөр ялгарал",
    "High Saturation": "Өндөр ханалт",
    "Low Saturation": "Бага ханалт",
    "Monochrome": "Нэг өнгө",
    "Tools": "Хэрэгслүүд",
    "Reading Guide": "Унших гарын авлага",
    "Big Cursor": "Том курсор",
    "Increase Font Size": "Фонтын хэмжээг нэмэгдүүлэх",
    "Decrease Font Size": "Фонтын хэмжээг багасгах",
    "Letter Spacing": "Үсгийн хоорондын зай",
    "Line Height": "Мөрийн өндөр",
    "Font Weight": "Фонтын жин",
    "Dyslexia Font": "Дислекси фонт",
    "Language": "Хэл",
    "Accessibility widget": "Хандалтын цэсийг нээх",
    "Accessibility Profiles": "Хандалтын профайлууд",
    "Cognitive Disability": "Танин мэдэхүйн хөгжлийн бэрхшээл",
    "Seizure Safe": "Тархины цочролд аюулгүй",
    "Accessibility statement": "Хандалтын мэдэгдэл",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Анимацийг зогсоох",
    "Reset all settings": "Тохиргоог дахин тохируулах",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
